module.exports = __webpack_public_path__ + "static/media/cherry-bg.87684c44.mp4";